module.exports = __webpack_public_path__ + "static/media/nodejs-1.a1231528.svg";